import styled from "styled-components";
import { MEDIA_QUERIES } from "context/media/MediaConstant";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

export const StyledTitleWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: ${DIGIPOSTHEME.colors.headerRed};
  margin: 30px 0;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 8px 0 22px 0;
  }
`;

export const StyledShortcuts = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 125px;
  margin: 10px 0;
  padding: 10px 0;
  border-radius: 6px;
  background-color: ${DIGIPOSTHEME.colors.white};
`;

export const StyledShortcutsCircleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80px;
  align-items: center;
`;

export const StyledShortcutsIconCircle = styled.div`
  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 14%) 0px 2px 2px 1px;
  padding: 10px;
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  cursor: pointer;

  &:active {
    transform: scale(0.9);
  }
  &:hover {
    box-shadow: rgb(136 8 8 / 74%) 0px 2px 2px 1px;
  }
`;

export const StyledFaqItem = styled.div`
  margin: 8px 0;
  padding: 20px;
  width: 100%;
  background-color: ${DIGIPOSTHEME.colors.white};
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

  &:hover > p {
    background-color: ${DIGIPOSTHEME.colors.whiteGrey};
    color: ${DIGIPOSTHEME.colors.headerRed};
  }
`;
